import React, { useState } from 'react';

import { db } from '../firebase';

import { doc, updateDoc, serverTimestamp, collection, addDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';





// --- MODAL STYLES ---

const modalOverlayStyle = {

    position: 'fixed',

    top: 0,

    left: 0,

    right: 0,

    bottom: 0,

    backgroundColor: 'rgba(0, 0, 0, 0.5)',

    display: 'flex',

    justifyContent: 'center',

    alignItems: 'center',

    zIndex: 2000,

};



const modalContentStyle = {

    backgroundColor: 'white',

    padding: '25px',

    borderRadius: '10px',

    width: '90%',

    maxWidth: '500px',

    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',

    animation: 'fadeIn 0.3s'

};

// --- END MODAL STYLES ---





export default function GuestRequestButtons({ guestId, roomNumber, hotelId, roomId }) {

    const [loading, setLoading] = useState(false);

    const [requestStatus, setRequestStatus] = useState(null); // 'success', 'error', 'pending'

    const [isMaintenanceModalOpen, setIsMaintenanceModalOpen] = useState(false); // New state for modal

    const [maintenanceDetails, setMaintenanceDetails] = useState(''); // New state for custom input
    const { t } = useTranslation();
    const REQUEST_OPTIONS = [
        { name: t('requests.cleaning'), type: 'Housekeeping (Cleaning)', details: t('requests.cleaning_desc'), icon: '🧹', isCustom: false },
        { name: t('requests.towels'), type: 'Extra Towels', details: t('requests.towels_desc'), icon: '🛁', isCustom: false },
        { name: t('requests.maintenance'), type: 'Maintenance', details: t('requests.maintenance_desc'), icon: '🛠️', isCustom: true },
        { name: t('requests.misc'), type: 'Misc Service', details: t('requests.misc_desc'), icon: '🛎️', isCustom: false },
    ];


    // --- GENERIC REQUEST HANDLER (used for Cleaning, Towels, Misc) ---

    const sendRequest = async (requestType, requestDetails) => {

        if (!guestId) return;

        setLoading(true);

        setRequestStatus('pending');



        try {

            // 1. Write to the 'requests' history collection (Good practice for auditing)

            await addDoc(collection(db, 'requests'), {

                hotelId: hotelId,

                guestId: guestId,

                roomNumber: roomNumber,

                roomId: roomId,

                type: requestType,

                details: requestDetails,

                status: 'new',

                timestamp: serverTimestamp(),

            });



            // 2. 🔥 CRITICAL FIX: Update the GUEST DOCUMENT for the DASHBOARD LISTENER

            const guestRef = doc(db, 'guests', guestId);

            await updateDoc(guestRef, {

                hasPendingRequest: true,

                // These three fields are what the Staff Dashboard is listening for:

                requestType: requestType,

                requestDetails: requestDetails, // <--- DETAIL IS NOW WRITTEN HERE

                requestTimestamp: serverTimestamp(),

            });

            // ------------------------------------------------------------------



            setRequestStatus('success');

            setTimeout(() => setRequestStatus(null), 5000);

        } catch (error) {

            console.error("Failed to send guest request:", error);

            setRequestStatus('error');

        } finally {

            setLoading(false);

        }

    };

   

    // --- MAINTENANCE REQUEST HANDLER (handles custom input) ---

    const handleMaintenanceRequest = async (e) => {

        e.preventDefault();

       

        if (!guestId || maintenanceDetails.trim() === '') {

            alert("Please describe the maintenance issue.");

            return;

        }



        const requestType = 'Maintenance';

       

        // Pass the user's detailed input as the request details

        await sendRequest(requestType, maintenanceDetails.trim());

       

        // Close and clear the modal after sending

        setIsMaintenanceModalOpen(false);

        setMaintenanceDetails('');

    };



    return (

        <div className="card" style={{ marginBottom: '20px', padding: '15px' }}>

            <h4 style={{marginTop: 0, marginBottom: '15px'}}>{t('requests.title', { room: roomNumber })}</h4>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>

                {REQUEST_OPTIONS.map(option => (

                    <button

                        key={option.type}

                        onClick={option.isCustom

                            ? () => setIsMaintenanceModalOpen(true) // Open modal for Maintenance

                            : () => sendRequest(option.type, option.details) // Send generic request

                        }

                        disabled={loading || requestStatus === 'pending'}

                        style={{

                            flex: '1 1 150px',

                            minWidth: '120px',

                            padding: '15px 10px',

                            border: '1px solid #ddd',

                            borderRadius: '8px',

                            backgroundColor: option.isCustom ? '#fff8e1' : 'white', // Highlight maintenance button

                            cursor: 'pointer',

                            transition: 'background-color 0.2s',

                            textAlign: 'center',

                            fontWeight: 'bold',

                        }}

                        title={option.details}

                    >

                        <span style={{ fontSize: '1.5em', display: 'block' }}>{option.icon}</span>

                        {/* 🔥 UI ENHANCEMENT: Display the name of the service */}

                        <span style={{ display: 'block', fontSize: '0.9em', marginTop: '5px' }}>{option.name}</span>

                        {/* END UI ENHANCEMENT */}

                    </button>

                ))}

            </div>

           

            {/* Status Messages */}

            {requestStatus === 'success' && (

                <p style={{ color: 'green', textAlign: 'center', marginTop: '15px', fontWeight: 'bold' }}>{t('requests.msg_success')}</p>

            )}

            {requestStatus === 'error' && (

                <p style={{ color: 'red', textAlign: 'center', marginTop: '15px' }}>{t('requests.msg_error')}</p>

            )}

           

            {/* --- MAINTENANCE REQUEST MODAL --- */}

            {isMaintenanceModalOpen && (

                <div style={modalOverlayStyle}>

                    <div style={modalContentStyle}>

                        <h4 style={{ marginTop: 0, borderBottom: '1px solid #eee', paddingBottom: '10px' }}>

                            🛠️ {t('requests.mod_title')}

                        </h4>

                        <form onSubmit={handleMaintenanceRequest}>

                            <p>{t('requests.mod_desc')}</p>

                            <textarea

                                value={maintenanceDetails}

                                onChange={(e) => setMaintenanceDetails(e.target.value)}

                                placeholder={t('requests.mod_placeholder')}

                                rows="5"

                                style={{ width: '100%', padding: '10px', boxSizing: 'border-box', marginBottom: '15px', border: '1px solid #ccc', borderRadius: '4px' }}

                                required

                            />

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>

                                <button

                                    type="button"

                                    onClick={() => setIsMaintenanceModalOpen(false)}

                                    disabled={loading}

                                    style={{ padding: '10px 15px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}

                                >

                                    {t('registration.btn_cancel')}

                                </button>

                                <button

                                    type="submit"

                                    disabled={loading}

                                    style={{ padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}

                                >

                                    {loading ? t('checker.searching') : t('feedback.btn_submit')}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}

            {/* --- END MAINTENANCE REQUEST MODAL --- */}

        </div>

    );

}